import * as React from 'react';
import ReactDOM from 'react-dom';
import styles from './index.less';
import { MicroApp } from 'umi';
import * as AHooks from 'ahooks';
import { getMicroAppName } from '@/constants';
import MicroAppStateActionsMgr from '@/utils/MicroAppStateActionsMgr';

interface FMicroApp_SignResourceToNode_3_Props {
  nodeID?: number;
  onSuccess?: (info: { exhibtID: string; nodeID: number }) => void;
  onClose?: () => void;
}

function FMicroApp_SignResourceToNode_3({
  nodeID,
  onSuccess,
  onClose,
}: FMicroApp_SignResourceToNode_3_Props) {
  AHooks.useMount(() => {
    MicroAppStateActionsMgr.actions.onGlobalStateChange((state: any, prev: any) => {
      if (state.authProcessorShow === false) {
        setTimeout(() => {
          onClose?.();
        }, 200);
      }
    }, false);
  });

  return ReactDOM.createPortal(
    <MicroApp
      name={
        getMicroAppName('ResourceSignNode')
      }
      licenseeId={nodeID}
      mainAppType={'resourceToNode'}
      mainAppFuncs={{
        signedToNode({ presentableId, nodeId }: any) {
          onSuccess?.({ exhibtID: presentableId, nodeID: nodeId });
        },
      }}
    />,
    self.document.body,
  );
}

export default FMicroApp_SignResourceToNode_3;

interface IState {
  authProcessorShow: true;
  licensorId: string;
  licensorResourceVersion: string;
}

export function setState_FMicroApp_SignResourceToNode_3(state: Partial<IState>) {
  MicroAppStateActionsMgr.setState(state);
}
